<script>
  import { init, _ } from "svelte-i18n";

  export let selectedCategories = [];
  export let query_vars = [];
  export let products = [];
</script>

<ul class="products columns-4">
  {#each products as product}
    <li
      class="product type-product post-{product.id} status-publish first outofstock has-post-thumbnail shipping-taxable purchasable product-type-variable"
    >
      <div class="product-block">
        <div class="product-transition">
          <div class="product-image">
            {#if product.on_sale}
              <span class="onsale">{$_("product_list.On Sale!")}</span>
            {/if}
            <a href={product.permalink}>
              {#if product.images.length > 0}
                <img
                  width="450"
                  src={product.images[0].src + ".webp"}
                  alt={product.name}
                />
              {:else}
                <img
                  width="450"
                  src={"/wp-content/uploads/woocommerce-placeholder.png"}
                  alt={product.name}
                />
              {/if}
            </a>
          </div>
          {#if false && product.stock_quantity < 1}
            <span class="stock-label">{$_("product_list.Out of stock")}</span>
          {/if}
          <div class="group-action">
            <div class="shop-action">
              <button
                class="woosw-btn woosw-btn-{product.id}"
                data-id={product.id}
                >{$_("product_list.Add to wishlist")}</button
              ><button
                class="woosq-btn woosq-btn-{product.id} "
                data-id={product.id}
                data-effect="mfp-3d-unfold"
                >{$_("product_list.Quick view")}</button
              >
            </div>
          </div>
        </div>
        <h3 class="woocommerce-loop-product__title">
          <a href={product.permalink}>{product.name}</a>
        </h3>
        <span class="notranslate price" html>
          {@html product.price_html}
        </span>
        <a
          href={product.permalink}
          data-quantity="1"
          class="button product_type_variable"
          data-product_id={product.id}
          data-product_sku={products.sku}
          aria-label={product.name}
          rel="nofollow">{$_("product_list.Choose option")}</a
        >
      </div>
    </li>
  {/each}
</ul>

<style>
  /* .products {
        display: flex;
        flex-wrap: wrap
    }
    .products li {
        width: 33.33%;
    }
    .product-image img {
        max-width: 300px;
    } */
</style>
